var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_1377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 15.5835H11.9166V10.0835H10.0833V15.5835ZM11 8.25016C11.2597 8.25016 11.4774 8.16232 11.6531 7.98662C11.8288 7.81093 11.9166 7.59322 11.9166 7.3335C11.9166 7.07377 11.8288 6.85607 11.6531 6.68037C11.4774 6.50468 11.2597 6.41683 11 6.41683C10.7403 6.41683 10.5225 6.50468 10.3469 6.68037C10.1712 6.85607 10.0833 7.07377 10.0833 7.3335C10.0833 7.59322 10.1712 7.81093 10.3469 7.98662C10.5225 8.16232 10.7403 8.25016 11 8.25016ZM11 20.1668C9.73192 20.1668 8.54026 19.9262 7.42498 19.445C6.3097 18.9637 5.33956 18.3106 4.51456 17.4856C3.68956 16.6606 3.03644 15.6904 2.55519 14.5752C2.07394 13.4599 1.83331 12.2682 1.83331 11.0002C1.83331 9.73211 2.07394 8.54044 2.55519 7.42516C3.03644 6.30989 3.68956 5.33975 4.51456 4.51475C5.33956 3.68975 6.3097 3.03662 7.42498 2.55537C8.54026 2.07412 9.73192 1.8335 11 1.8335C12.268 1.8335 13.4597 2.07412 14.575 2.55537C15.6903 3.03662 16.6604 3.68975 17.4854 4.51475C18.3104 5.33975 18.9635 6.30989 19.4448 7.42516C19.926 8.54044 20.1666 9.73211 20.1666 11.0002C20.1666 12.2682 19.926 13.4599 19.4448 14.5752C18.9635 15.6904 18.3104 16.6606 17.4854 17.4856C16.6604 18.3106 15.6903 18.9637 14.575 19.445C13.4597 19.9262 12.268 20.1668 11 20.1668ZM11 18.3335C13.0472 18.3335 14.7812 17.6231 16.2021 16.2022C17.6229 14.7814 18.3333 13.0474 18.3333 11.0002C18.3333 8.95294 17.6229 7.21891 16.2021 5.79808C14.7812 4.37725 13.0472 3.66683 11 3.66683C8.95276 3.66683 7.21873 4.37725 5.7979 5.79808C4.37706 7.21891 3.66665 8.95294 3.66665 11.0002C3.66665 13.0474 4.37706 14.7814 5.7979 16.2022C7.21873 17.6231 8.95276 18.3335 11 18.3335Z",
    fill: "url(#paint0_linear_44_1377)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1377",
    x1: 11,
    y1: 1.8335,
    x2: 11,
    y2: 20.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.56f10f1da07d39840ce2bbbe71af53ad.svg";
export { ForwardRef as ReactComponent };